import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '@core/services/dialog.service';
import { VisitWrapperService } from '@core/services/service-wrappers/visit-wrapper.service';
import type { UserDetailsViewModel, VisitDetailsViewModel } from 'data';
import { SPLIT_VISIT_DIALOG_COMPONENT, VISIT_RULES_DIALOG_COMPONENT } from '../dialog-component-tokens';

export interface CustomVisitDetailsViewModel extends VisitDetailsViewModel {
  primaryInsurance: any;
  secondaryInsurance: any;
  tertiaryInsurance: any;
}

@Component({
  standalone: false,
  selector: 'lib-visit-details',
  templateUrl: './visit-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./visit-details.component.scss']
})
export class VisitDetailsComponent implements OnInit, AfterViewInit {
  @ViewChild('rulesAppliedButton', { read: ElementRef }) rulesAppliedButton: ElementRef<HTMLButtonElement>;

  @Input()
  visit: CustomVisitDetailsViewModel;
  billProcedure: any[];
  rules;

  @Input()
  viewOnly: boolean;

  @Input()
  userInfo: UserDetailsViewModel;

  @Output() visitAction: EventEmitter<any> = new EventEmitter<any>();
  @Output() editProcedure: EventEmitter<string> = new EventEmitter<string>();
  @Output() reverseProcedure: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    public dialog: MatDialog,
    private dialogService: DialogService,
    public visitService: VisitWrapperService,
    private renderer: Renderer2,
    @Optional() @Inject(SPLIT_VISIT_DIALOG_COMPONENT) private splitVisitDialogComponent: ComponentType<unknown>,
    @Optional() @Inject(VISIT_RULES_DIALOG_COMPONENT) private visitRulesDialogComponent: ComponentType<unknown>
  ) {}

  ngOnInit(): void {
    this.billProcedure = new Array(this.visit?.procedureTransactions?.length ?? 0);
    for (let i = 0; i < this.billProcedure.length; i++) {
      this.billProcedure[i] = true;
    }

    this.visitService
      .apiV1VisitGetVisitRulesIdPost(this.visit?.id)
      .subscribe((result) => {
        this.rules = result;
        this.updateRulesButtonVisibility();
      });
  }

  ngAfterViewInit(): void {
    this.updateRulesButtonVisibility();
  }

  private updateRulesButtonVisibility(): void {
    const rulesAppliedButton = this.rulesAppliedButton?.nativeElement;
    if (this.rules?.length > 0 && rulesAppliedButton) {
      this.renderer.removeClass(rulesAppliedButton, 'rules-applied-button--hidden');
    }
  }

  notImplemented() {
    throw new Error('Feature not implemented');
  }
  billProcedureChanged($event) {
    this.billProcedure[$event.procedureNumber - 1] = $event.bill;
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  splitVisit() {
    if (this.visit?.procedureTransactions.length > 1 && this.splitVisitDialogComponent) {
      const dialog = this.dialog.open(this.splitVisitDialogComponent, {
        disableClose: true,
        autoFocus: false,
        data: { visit: this.visit }
      });
    }
  }

  getVisitRules() {
    if (!this.visitRulesDialogComponent) {
      return;
    }

    const dialog = this.dialog.open(this.visitRulesDialogComponent, {
      data: {
        rules: this.rules
      }
    });
  }
}
